<template>
    <div class="table-responsive" style="overflow: auto;  max-height: 70vh">
        <h3 v-if="title" >{{ title }}</h3>
        <table class="table" style="text-align: center;">
            <thead>
            <tr style="border: 1px solid #EBEDF3">
                <th scope="col" v-for="(key, column) in columns" class="w-[100px] header-table" :key="key">{{ key }}</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="item of responseError" :key="item?.index" style="border: 1px solid #EBEDF3; border-top: 0">
                    <td scope="col" v-for="(key, column) in columns" class="w-[100px] header-table" :key="key">
                        <div v-if="typeof item[column]  === 'string'">
                            {{ item[column] }}
                        </div>
                        <div v-else>
                            <div v-if="typeof item[column]  === 'object' && item[column].length > 0" style="width:200px; text-align: start; display: flex; flex-direction: column; color: red; font-weight: 500">
                                <span>Lỗi:</span>
                                <span v-for="(error, index) in item.errors" :key="index + error"
                                      style="word-break: break-word;">
                                - {{ error }}
                            </span>
                            </div>
                            <span v-else style="color: #0C9200; font-weight: 500">Đạt</span>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>


export default {
    name: 'TableImportErrorGlobal',
    data() {
        return {}
    },
    props: {
        responseError: {
            type: Array,
            required: true,
            default: []
        },
        columns: {
            type: Object,
            required: true,
            default: []
        },
        title: {
            type: String,
        }
    },
    methods: {

    }
}
</script>

<style lang="css" scoped>
.header-table {
    background: #F8F8F8;
    text-align: start;
    word-break: break-word;
}
</style>